import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import { DeleteIcon } from 'ui-component/custom-icons/icons';
import Pagination from 'ui-component/Pagination';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { Skeleton } from '@mui/material';
import toast from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePageTitle from 'hooks/usePageTitle';
import SpecificationModal from './modals/SpecificationModal';
import useIsMobile from 'utils/isMobileUtils';
// ✅ Clear
const SettingsSpecifications = () => {
    const [setPageTitle] = usePageTitle('Settings');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const history = useNavigate();
    const [showDelete, setShowDelete] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setpagination] = useState([]);

    const [searchField, setSearchField] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [recordLists, setRecordLists] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState({
        id: '',
        name: '',
    });

    const isMobile = useIsMobile();

    const getRecordsLists = () => {
        setIsLoading(true);
        api
            .getSettingsSpecifications()
            .then((res) => {
                setIsLoading(false);
                if (res.status) {
                    setRecordLists(res?.data?.data);
                    setpagination(res?.data);
                } else {
                    setRecordLists([]);
                }
                isFirstLoad && setIsFirstLoad(false);
            })
            .catch((error) => {
                setIsLoading(false);
                setRecordLists([]);
                console.error('Failed to fetch data:', error);
            });
    };
    const handleSearch = (e) => {
        let text = e.target.value;
        setSearchField(text);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        let timeout = setTimeout(() => {
            setIsLoading(true);
            if (text.length > 2) {
                api.filterSpecifications(activeFilters, text).then((res) => {
                    setIsLoading(false);
                    setRecordLists(res.data.data);
                    setpagination(res.data);
                });
            } else if (text.length > 0 && text.length <= 2) {
                setIsLoading(false);
            } else {
                api.filterSpecifications(activeFilters, null).then((res) => {
                    setIsLoading(false);
                    setRecordLists(res.data.data);
                    setpagination(res.data);
                });
            }
        }, 1000);

        setSearchTimeout(timeout);
    };

    useEffect(() => {
        !isFirstLoad && handleFilter();
    }, [activeFilters]);

    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterSpecifications(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
            setRecordLists(res.data.data);
            setpagination(res.data);
        });
    };

    const handleClose = () => { 
        setShowModal(false)
        setShowDelete(null);
    }
    const handleReloadList = () => { 
        setShowModal(false)
        setSelectedRecord({
            ...selectedRecord,
            id: '',
            name: '',
        })
        getRecordsLists();
    }

    const handleData = (data) => {
        setRecordLists(data.data);
        setpagination(data);
    };

    useEffect(() => {
        getRecordsLists();
    }, []);
    
    const handleCreateRecord = () => {
        setShowModal(true);
        setSelectedRecord({
            ...selectedRecord,
            id: '',
            name: '',
        })
    }

    const handleDelete = (id) => {
        toast.promise(
            api.settingsDeleteSpecification(showDelete?.id).then((res) => {
                if (res.status) {
                    handleClose();
                    getRecordsLists()
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting specification...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete specification</b>
            }
        );
    };

    const deleteRecord = (data) => {
        setShowDelete(data);
    };

    useEffect(() => {
        if (showModal) {
          window.addEventListener('keydown', handleKeyDown);
        } else {
          window.removeEventListener('keydown', handleKeyDown);
        }
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showModal]);

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          setShowModal(false);
        }
    };
    
    return (
        <>
            <div className="row">
                <div className={`${isMobile ? 'col-xl-12 col-lg-12' : 'col-lg-6 col-md-6 col-12 offset-lg-3 offset-md-3'}`}>
                    
                    {isMobile && (
                        <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
                            <div className="header-bubble" />
                            <div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
                                <div
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: 8,
                                        minHeight: 38
                                    }}
                                >
                                    <button
                                        type="button"
                                        aria-label="Back"
                                        onClick={() => history(-1)}
                                        className="circle-back-btn"
                                        style={{
                                            position: 'absolute',
                                            left: 20,
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        }}
                                    >
                                        <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                                            <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                    <h5
                                        style={{
                                            textAlign: 'center',
                                            flex: 1,
                                            margin: 0,
                                            display: 'flex',
                                            gap: 10,
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Specifications
                                    </h5>
                                </div>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <PermissionAllowed permissions={['List Purchase Order']}>
                                        <button
                                            className="bulk-action btn-primary btn-outlined-main-primary  white-var"
                                            onClick={handleCreateRecord}
                                        >
                                            <span className="menuIcon">
                                                <FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
                                            </span>
                                            <span>New</span>
                                        </button>
                                    </PermissionAllowed>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Desktop header */}
                    {!isMobile && (
                        <div className="section-head-new" style={{ margin:'10px 20px 0px 1px'}}>
                            <div className="actions">
                                <PermissionAllowed permissions={['List Purchase Order']}>
                                    <button
                                        className="bulk-action btn-primary btn-outlined-main-primary  white-var"
                                        onClick={handleCreateRecord}
                                    >
                                        <span className="menuIcon">
                                            <FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
                                        </span>
                                        <span>New</span>
                                    </button>
                                </PermissionAllowed>
                            </div>
                        </div>
                    )}
                    {/* Mobile search bar */}
                    {isMobile && (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 10,
                                paddingTop: 0,
                                paddingBottom: 5,
                                paddingLeft: 20,
                                paddingRight: 20
                            }}
                            className="show-on-mobile"
                        >
                            <form className="form-inline navbar-search" style={{ flex: 1 }}>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type="text"
                                        className="form-control bg-white border"
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon2"
                                        onChange={handleSearch}
                                        style={{ width: '100%', paddingRight: 36 }}
                                    />
                                    <span
                                        className="searchIcon"
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#888',
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <FaSearch />
                                    </span>
                                </div>
                            </form>
                        </div>
                    )}
                    <div className={`card shadow-sm bg-white mb-4 ${isMobile ? 'table-card shorter-table' : ''}`}>
                        <div className=" align-items-center justify-content-between TableSerachBar">
                            <div>
                                <div className="actions">
                                    <div style={{ margin: '0 5px' }}>
                                        <h5>Specifications</h5>
                                    </div>
                                </div>
                            </div>
                            {!isMobile && (
                                <form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control bg-white border"
                                            placeholder="Search"
                                            aria-label="Search"
                                            aria-describedby="basic-addon2"
                                            onChange={handleSearch}
                                            style={{ width: '100%' }}
                                        />
                                        <span className="searchIcon">
                                            <FaSearch />
                                        </span>
                                    </div>
                                </form>
                            )}
                        </div>
                        {!isMobile ? (
                            <div className="table-responsive-xl tableData customersList p-2 mt-16">
                                <table className="table pm-table">
                                    <thead>
                                        <tr className="sticky-header">
                                            <th scope="col" className=" font500">Specification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            [...Array(10)].map((e, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <>
                                                {recordLists?.map((row, index) => (
                                                    <tr key={index} className="hover-row">
                                                        <td
                                                            className="align-middle cursor-pointer"
                                                            onClick={() => {
                                                                setShowModal(true);
                                                                setSelectedRecord({
                                                                    ...selectedRecord,
                                                                    id: row.id,
                                                                    name: row.name,
                                                                })
                                                            }}
                                                        >
                                                            {row?.name}
                                                        </td>
                                                        <td className="hover-button-container">
                                                            <div>
                                                                <div className="hover-button">
                                                                    <PermissionAllowed permissions={['Delete Operations']}>
                                                                        <div
                                                                            className='btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer'
                                                                            style={{ marginLeft: '8px' }}
                                                                            onClick={() => {
                                                                                deleteRecord(row);
                                                                            }}
                                                                        >
                                                                            <div style={{ margin: 'auto 3px' }}>
                                                                                <DeleteIcon height="14px" width="14px" />
                                                                            </div>
                                                                        </div>
                                                                    </PermissionAllowed>
                                                                </div>
                                                            </div>
                                                        </td> 
                                                    </tr>
                                                ))}
                                                {recordLists?.length < 1 && (
                                                    <tr className="no-hover">
                                                        <td className="whitebg">
                                                            <div className="not-found-container">
                                                                <div className="not-found-icon">
                                                                    <img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
                                                                </div>
                                                                <h6 className="not-found-text">No Data Available</h6>
                                                                <div
                                                                    className="cursor-pointer btn btn-primary btn-outlined-main"
                                                                    onClick={handleCreateRecord}
                                                                >
                                                                    Create Specification
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div
                                className="mobile-product-list"
                                style={{
                                    height: 'calc(100dvh - 300px)',
                                    overflowY: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                {isLoading ? (
                                    [...Array(10)].map((_, i) => (
                                        <div
                                            key={i}
                                            className="mobile-product-card skeleton"
                                            style={{
                                                borderRadius: 12,
                                                background: '#f5f5f5',
                                                padding: 16,
                                                minHeight: 60,
                                                marginBottom: 8
                                            }}
                                        >
                                            <Skeleton variant="rounded" width={'100%'} height={30} />
                                        </div>
                                    ))
                                ) : recordLists?.length > 0 ? (
                                    recordLists.map((row, index) => (
                                        <div
                                            key={index}
                                            className="mobile-product-card"
                                            style={{
                                                borderBottom: '1px solid #eee',
                                                padding: '10px 20px',
                                                background: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                width: '100%'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: 16,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    setShowModal(true);
                                                    setSelectedRecord({
                                                        ...selectedRecord,
                                                        id: row.id,
                                                        name: row.name,
                                                    })
                                                }}
                                            >
                                                {row?.name}
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <PermissionAllowed permissions={['Delete Operations']}>
                                                    <div
                                                        className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
                                                        style={{ marginLeft: 8, padding: 6, borderRadius: 6 }}
                                                        onClick={() => deleteRecord(row)}
                                                    >
                                                        <div style={{ margin: 'auto 3px' }}>
                                                            <DeleteIcon height="14px" width="14px" />
                                                        </div>
                                                    </div>
                                                </PermissionAllowed>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ textAlign: 'center', color: '#888', padding: 24 }}>
                                        <div className="not-found-icon" style={{ fontSize: 32, marginBottom: 8 }}>
                                            <img src={NoRecordFoundIcon} style={{ height: '120px', width: '120px' }} />
                                        </div>
                                        <div style={{ fontSize: 15, marginBottom: 12 }}>No Data Available</div>
                                        <div
                                            className="cursor-pointer btn btn-primary btn-outlined-main"
                                            onClick={handleCreateRecord}
                                        >
                                            Create Specification
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        <Pagination pagination={pagination} data={handleData} onLoading={(e) => setIsLoading(e)} />
                        <div style={{ marginBottom: '8px'}}></div>
                    </div>
                </div>
            </div>
            {showDelete && (
                <DeleteConfirmation
                    show={showDelete}
                    handleClose={handleClose}
                    handleDelete={handleDelete}
                    title="Confirm"
                    message={`Are you sure you want to delete ${showDelete?.name}?`}
                    customDeleteButtonText={'Yes, Delete this record'}
                />
            )}
            {showModal && (
                <SpecificationModal
                    openPopup={showModal}
                    details={selectedRecord}
                    handleClose={handleClose}
                    handleReloadList={handleReloadList}
                />
            )}
        </>
    );
};

export default SettingsSpecifications;
